import { MessageInfo } from "../../../../types/info";
import { SimulationLatestAction } from "../../../../types/actions";
import { GetSimulationV3Response } from "../../../../../../server/types/request/report/simulation/v3";
import { SalesVolumePrediction } from "../../../../../../server/analytics/sales-volume";
import { SalesVolumeCorrectionValue } from "../../../../../../server/models/simulation-value";

export type SalesVolumePredictionData = {
	value: SalesVolumePrediction;
	correctionValue: SalesVolumeCorrectionValue;
};

export type State = GetSimulationV3Response & {
	loading: boolean;
	info: MessageInfo;
	confirmMessage: string | undefined;
};

export const initState: State = {
	oneNumberScoreNorm: undefined,
	oneNumberScoreData: [],
	job: undefined,
	activity: undefined,
	goalSalesVolume: 0,
	goalRecognitionRate: undefined,
	loading: true,
	info: {
		isSuccess: true,
		message: "",
	},
	evaluations: [],
	maxRecognition: 0,
	referenceSourceData: undefined,
	constant: undefined,
	simulationPredictionData: {},
	currentProduct: undefined,
	confirmMessage: undefined,
};

export const reducer = (state: State, action: SimulationLatestAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				loading: false,
				confirmMessage: undefined,
				...action.payload,
			};
		case "updateData":
			return {
				...state,
				loading: false,
				confirmMessage: undefined,
				...action.payload,
				info: { message: "保存が完了しました。", isSuccess: true },
			};
		case "clearCPData":
			return {
				...state,
				loading: false,
				confirmMessage: undefined,
				...action.payload,
				info: { message: "CP実績補正のクリアが完了しました。", isSuccess: true },
			};
		case "changeRatio":
			return {
				...state,
				confirmMessage: "保存せずにページを移動すると入力内容がクリアされます。移動してよろしいでしょうか。",
				simulationPredictionData: {
					...state.simulationPredictionData,
					[action.payload.target]: {
						...state.simulationPredictionData[action.payload.target],
						correctionValue: {
							...state.simulationPredictionData[action.payload.target].correctionValue,
							[action.payload.name]: action.payload.value,
						},
					},
				},
			};
		case "changeCP": {
			return {
				...state,
				confirmMessage:
					"CP値を入力し、推計値算出まで実施しないとCP実績補整は提案フォーマットに反映されません。\n移動してよろしいでしょうか。",
				currentProduct: {
					...state.currentProduct,
					correctionValue: {
						...state.currentProduct?.correctionValue,
						[action.payload.name]: action.payload.value,
					},
				},
			};
		}
		case "changeMessageInfo":
			return {
				...state,
				loading: false,
				info: action.payload,
			};
		case "downloadSimulation":
			return {
				...state,
				loading: false,
				confirmMessage: undefined,
			};
		case "saveSimulation":
			return {
				...state,
				info: action.payload,
				loading: false,
				confirmMessage: action.payload.isSuccess ? undefined : state.confirmMessage,
			};
		case "setChanged":
			return { ...state, confirmMessage: action.payload ? state.confirmMessage : undefined };
		case "changeLoading":
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};
